import { useControlsState } from './useControlsState';

export type OverviewTimeRange = '30-days' | 'all-time';

export const useOverviewTimeRange = () => useControlsState<OverviewTimeRange>('overview-time-range', 'all-time');
